import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecproject/cecProject/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecproject/cecProject/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecproject/cecProject/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecproject/cecProject/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecproject/cecProject/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecproject/cecProject/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecproject/cecProject/import',
      method: 'post',
      data: data
    })
  },

  getCecUpdateProject: function (params) {
    return request({
      url: '/cecproject/cecProject/getCecUpdateProject',
      method: 'post',
      params: params
    })
  },
  getCecDataSheet: function (type) {
    return request({
      url: '/cecproject/cecProject/getCecDataSheet',
      method: 'post',
      params: {type: type}
    })
  }
}
